import { TIMEZONE_OFFSET, S3_BASE_URL } from "@/constastants/Constant";
import moment from "moment";
import he from "he";

export const calculateReadingTime = (text, wordsPerMinute = 200) => {
  let calculatedtext = "";
  text?.map((data) => {
    calculatedtext = calculatedtext + data?.sectionHeading;
    calculatedtext = calculatedtext + data?.sectionText;
  });
  const words = calculatedtext.split(/\s+/).length;
  const minutes = words / wordsPerMinute;
  return Math.ceil(minutes);
};

export const getFormattedDate = (inputDate) => {
  const date = new Date(inputDate);
  const formattedDateString = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  return formattedDateString;
};

export const slugify = (text) => {
  if (text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }
};

// URL generation utilities
export const getProductUrl = (productId, productName) => {
  const slug = slugify(productName);
  return `/product/${slug}-${productId}`;
};

export const getIndustryUrl = (industryId, industryName) => {
  const slug = industryName.toLowerCase().replace(/\s+/g, "-");
  return `/industry/${slug}-${industryId}`;
};

export const unslugifySubCategory = (category, subCategory) => {
  // console.log("SlugDebug:", { category, subCategory });
  const industry = [
    "Water Treatment & Mining",
    "Personal Care",
    "C.A.S.E",
    "Chemical Intermediates",
    "Oil and Gas",
    "Food and Nutrition",
    "Flavours and Fragrance",
    "Home Care and Industrial Cleaning",
  ];

  const application = [
    "Surfactant",
    "Emulsifier",
    "Additives",
    "Neutraceutical",
    "Sweetner",
    "Plasticizers",
    "DCPD Chemistry",
    "UV Absorber",
    "PH Modifiers",
    "Drilling fluids",
    "Bleaching Agent",
    "Antimicrobial",
    "Thickener",
    "Corossion Inhibitors",
    "Citral Chemistry",
    "Thickeners and Rheology Modifiers",
    "Euclyptus Chemistry",
    "Binder",
    "Antioxidants",
    "Preservative",
    "Binder and Resin",
    "Coagulant",
    "Benzyl Chemistry",
    "Mint Chemistry",
    "Solvents",
    "Chelating agent",
    "Isoamyl Chemistry",
    "Scale Inhibitors",
    "Colorants",
    "Herbicide",
  ];

  const items = category === "industry" ? industry : application;
  // console.log("SlugDebug:", {
  //   category,
  //   subCategory,
  //   slugified: items.find((e) => slugify(e) === slugify(subCategory)),
  // });
  return items.find((e) => slugify(e) === slugify(subCategory));
};

export const generateWhyElchemyContent = (data) => {
  const firstTemplate = ` <div>
    <div>
      ${data?.productName ?? "This Product"} is a fundamental compound that is
      highly valued for its
      ${data?.application?.length ? data?.application.join(", ") : "various"}
      properties. It plays a crucial role in various industries
      ${
        data?.industries?.length
          ? `, including ${data?.industries.join(", ")}`
          : `.`
      }
      . The compound's unique properties make it particularly useful in modern
      applications and processes, improving efficiency and efficacy.
    </div>
    <div>
      Discovering the perfect chemical solution is more than just a
      transaction. It's a strategic partnership that propels your industry
      forward. At Elchemy, we believe in this philosophy and strive to embody
      it in every interaction. We leverage our strong affiliations with both
      Indian and global suppliers to provide an uninterrupted flow of
      high-quality chemicals that meet your dynamic needs. <br /><br />
      ${
        data?.brandName
          ? `All in all, ${data?.brandName}, is a versatile solution designed to enhance performance and drive efficiency in a variety of applications. `
          : ""
      }
      Our deep-rooted understanding of India's custom manufacturing prowess
      empowers us to navigate the intricacies of the global chemical landscape
      with unparalleled finesse. But that's not all. We're committed to
      mitigating every risk along the supply chain, from regulatory compliance
      to market fluctuations. <br /><br />
      Our team of tech-savvy experts has engineered a seamless solution to
      obliterate operational obstacles, supercharge supply chain efficiency,
      and provide you with unparalleled peace of mind. Our comprehensive suite
      of services encompasses everything from quality assurance to end-to-end
      logistics, with warehouses strategically positioned across the globe for
      swift, reliable delivery. <br /><br />
      Benefit from our extensive network of manufacturers, competitive pricing
      due to economies of scale, and digital tracking capabilities that offer
      unparalleled transparency and convenience. Experience the Elchemy
      difference today and embark on a journey to transform the future of your
      industry, one seamless transaction at a time.
    </div>
  </div>`;

  const secondTemplate = ` <div>
      <div>
        ${
          data?.productName ?? "This Product"
        } stands as a foundational compound esteemed for its exceptional
        properties  
        ${
          data?.application?.length
            ? `like ${data?.application.join(", ")}. `
            : "."
        }
        Its significance spans across diverse sectors such as
        ${data?.industries?.length ? `${data?.industries.join(", ")}` : `.`}
        . This   compound's   distinct
        characteristics   render   it   indispensable   in   contemporary   uses   and   procedures,
        enhancing   both   efficiency   and   effectiveness.   Its   unique   characteristics   make   it
        essential for modern applications, significantly enhancing overall performance and
        outcomes. <br/><br/>
        ${
          data?.brandName
            ? `All in all, ${data?.brandName}, is a versatile solution designed to enhance performance and drive efficiency in a variety of applications. `
            : ""
        }
      </div>
      <div>
      Finding the right chemical solution is not just about buying it; it is about building a
      strategic partnership that helps your industry grow. At Elchemy, we embrace this
      philosophy   in   every   interaction,   using   our   vast   network   of   Indian   and   global
      suppliers   to   ensure   a   smooth   supply   of   high-quality   chemicals   that   meet   your
      constantly changing needs. <br/><br/>
      With   a   deep   understanding   of   India's   expertise   in   custom   manufacturing,   we
      navigate  the  complexities  of  the  global  chemical  market  with  unmatched  skill.
      However, we are committed to more than just transactions. We are dedicated to
      mitigating   any   risks   that   may   arise   throughout   the   supply   chain,   including
      regulatory compliance and market fluctuations.<br/><br/>
      We   have   developed   a   comprehensive   solution   to   overcome   operational
      challenges, optimize supply chain efficiency, and provide you with unparalleled
      peace of mind. Our team of tech-savvy experts has designed a complete range of
      services, including stringent quality assurance and end-to-end logistics, supported
      by strategically located warehouses across the world.<br/><br/>
      Partnering with Elchemy means more than just buying chemicals; it means gaining
      a competitive advantage. Benefit from our extensive network of manufacturers,
      competitive   pricing,   and   state-of-the-art   digital   tracking   capabilities.   Take
      advantage of the Elchemy advantage today and embark on a journey to redefine
      success in the global chemical industry.
      </div>
    </div>`;

  const thirdTemplete = ` <div>
      <div>
        ${
          data?.productName ?? "This Product"
        } is revered for its outstanding properties  
        ${
          data?.application?.length
            ? `notably its ${data?.application.join(", ")}. `
            : "."
        }
        ts   importance   resonates   across   various   sectors such as
        ${
          data?.industries?.length ? `${data?.industries.join(", ")}` : ``
        } where it plays a crucial role
        . The exceptional traits of this compound
        make it indispensable in modern practices, boosting efficiency and efficacy. Its
        distinctive attributes are vital for contemporary applications, greatly improving
        overall performance and results. <br/><br/>
        ${
          data?.brandName
            ? `All in all, ${data?.brandName}, is a versatile solution designed to enhance performance and drive efficiency in a variety of applications. `
            : ""
        }
      </div>
      <div>
      Discover why Elchemy stands out in the field of chemical distribution and custom
manufacturing. Our unwavering commitment to customer-centricity drives us to
mitigate   supply   chain   risk,   ensure   stringent   quality   assurance,   and   navigate
complex regulatory landscapes with ease. With strong affiliations across Indian
and global suppliers, we possess a deep understanding of the industry's pulse,
enabling us to offer contractual agreements, market intelligence, and competitive
prices driven by economies of scale.<br/><br/>
At   Elchemy,   we   go   beyond   conventional   solutions.   Our   in-house   team   of   tech
experts has developed a cutting-edge platform to streamline operations, providing
seamless digital tracking and access to documents, ensuring peace of mind for our
customers. With warehouses strategically located worldwide and DDP shipments
for   door   delivery,   we   ensure   swift   and   efficient   logistics,   supplemented   by
necessary certifications and compliances.<br/><br/>
But it's not just about transactions; it's about relationships. We mitigate credit risk,
foster transparency, and prioritize customer satisfaction above all else. Whether
you're in pharmaceuticals, agriculture, or manufacturing, Elchemy is your trusted
partner   in   navigating   the   complexities   of   the   chemical   industry,   transforming
challenges into opportunities, one happy customer at a time.<br/><br/>
      </div>
    </div>`;

  const fourthTemplate = ` <div>
    <div>
      ${
        data?.productName ?? "This Product"
      }  is   highly   esteemed   for   its   exceptional   characteristics 
      ${
        data?.application?.length
          ? `particularly   its   remarkable  ${data?.application.join(", ")}. `
          : "."
      }
      Its   significance   extends
throughout   numerous   industries,
      ${
        data?.industries?.length
          ? `notably ${data?.industries.join(
              ", "
            )} here   it   holds   a   pivotal
          position.`
          : `.`
      } here   it   holds   a   pivotal
      position. The unique qualities of this compound render it indispensable in modern
      contexts, enhancing both efficiency and effectiveness. Its distinct properties are
      essential   for   contemporary   uses,   significantly   enhancing   overall   outcomes   and
      productivity <br/>
      ${
        data?.brandName
          ? `All in all, ${data?.brandName}, is a versatile solution designed to enhance performance and drive efficiency in a variety of applications. `
          : ""
      }
      <br/>
    </div>
    <div>
    Why Elchemy? When it comes to chemicals, your choice of supplier can make all
the difference. At Elchemy, we're not just another distributor—we're your strategic
partner in navigating the complex world of chemical sourcing and manufacturing. <br/><br/>
Our   extensive   network   of   Indian   and   global   suppliers   means   we   can   tap   into
substantial capacity to meet your chemical needs, no matter how demanding. But
it's not just about quantity; it's about quality too. With a deep understanding of
India's custom manufacturing prowess, we ensure that every product meets the
highest standards. <br/><br/>
But our commitment to customer-centricity goes beyond just sourcing chemicals.
We're here to mitigate supply chain risk, navigate compliance complexities, and
provide   end-to-end   logistics   solutions.   With   contractual   agreements,   quality
assurance, and market intelligence at your fingertips, you can trust Elchemy to
deliver not just chemicals, but peace of mind. <br/><br/>
Thanks to our in-house team of tech experts, we've streamlined the entire process.
From   digital   tracking   to   door   delivery,   we   leverage   technology   to   ensure   a
seamless experience for our customers. And with warehouses strategically located
around the world, we're always close by, ready to meet your needs. <br/><br/>
At Elchemy, we're not just transforming the future of the global chemical industry
—we're doing it one happy customer at a time. Choose Elchemy and experience
the difference for yourself.<br/><br/>
    </div>
  </div>`;

  const fifthTemplate = ` <div>
    <div>
      ${
        data?.productName ?? "This Product"
      } garners   widespread   acclaim   for   its   extraordinary   attributes
      ${
        data?.application?.length
          ? `particularly   its   outstanding   properties   like   ${data?.application.join(
              ", "
            )}. `
          : "."
      }
      Its   importance   spans
across various sectors,
      ${
        data?.industries?.length
          ? `most notably ${data?.industries.join(
              ", "
            )} where it occupies a crucial role.`
          : `.`
      } The   unmatched   traits   of   this   compound   make   it   indispensable   in   present-day
      scenarios, elevating both efficiency and efficacy. <br/><br/>
    </div>
    <div>
    Why should you choose Elchemy for your chemical needs? The answer is simple -
we are much more than just a distributor. We are a dynamic force that is reshaping
the chemical industry. We have strong affiliations with Indian and global suppliers,
which gives us unparalleled insight into the industry's capacity. This ensures that
we can meet worldwide demand with ease. <br/><br/>
${
  data?.brandName
    ? `All in all, ${data?.brandName}, is a versatile solution designed to enhance performance and drive efficiency in a variety of applications. `
    : ""
}
Our   expertise   in   custom   manufacturing,   combined   with   our   customer-centric
approach, positions us as your ideal partner. We understand the complexities of
the global chemical market, which is why we mitigate supply chain, documentary,
and compliance risks. This ensures seamless operations. We prioritize your peace
of mind by implementing rigorous quality assurance and contractual agreements.
Our market intelligence and arbitrage strategies keep you ahead of the curve,
while   our   end-to-end   logistics   and   strategically   located   warehouses   guarantee
efficient delivery. You can benefit from our DDP shipments and competitive prices,
fueled by economies of scale. Our extensive database of manufacturers and digital
tracking platform make managing your supply chain easier than ever before.<br/><br/>
At   Elchemy,   we   are   committed   to   navigating   the   complexities   of   the   chemical
industry and delivering excellence with every interaction. Trust us to help you
transform the future of chemicals, one satisfied customer at a time.<br/><br/>
    </div>
  </div>`;

  const sixthTemplate = ` <div>
  <div>
    ${
      data?.productName ?? "This Product"
    } is   praised   for   its   exceptional   characteristics
    ${
      data?.application?.length
        ? `,  especially   its
        remarkable   properties   such   as    ${data?.application.join(
          ", "
        )}. `
        : "."
    }
    Its   significance   extends   across
    diverse sectors
    ${
      data?.industries?.length
        ? `, notably ${data?.industries.join(
            ", "
          )} where it occupies a pivotal role.`
        : `.`
    } The unparalleled
    qualities of this compound make it indispensable in present-day scenarios. <br/><br/>
  </div>
  <div>
  Discover why Elchemy stands out in the realm of chemical distribution and custom
manufacturing. With a foundation built on robust affiliations with both Indian and
global suppliers, we possess a keen insight into their substantial capacity to meet
the burgeoning worldwide demand for chemicals. Leveraging India's prowess in
custom   manufacturing,   we   navigate   the   landscape   with   finesse,   addressing
challenges faced by both suppliers and customers.<br/><br/>
${
  data?.brandName
    ? `All in all, ${data?.brandName}, is a versatile solution designed to enhance performance and drive efficiency in a variety of applications. `
    : ""
}
At Elchemy, customer-centricity isn't just a principle—it's our driving force. Our in-
house team of tech expert’s solutions that obliterate operational obstacles, fortify
supply chain efficiency, and seamlessly adapt to fluctuating demand and supply
dynamics. With a steadfast commitment to mitigating risks at every turn, we offer
a comprehensive suite of value-added services.<br/><br/>
From mitigating supply chain and documentary compliance risks to ensuring top-
notch quality assurance, our offerings span contractual agreements, credit risk
mitigation,   and   market   intelligence   arbitrage.   With   warehouses   strategically
positioned across the globe, end-to-end logistics solutions, and DDP shipments, we
ensure seamless operations from start to finish.<br/><br/>
Benefit from our competitive pricing, courtesy of economies of scale, and gain
access to our extensive database of manufacturers in India and China. Experience
peace of mind with our digital tracking and document access platform, providing
unparalleled transparency and convenience. Choose Elchemy and embark on a
journey   to   transform   your   chemical   procurement   experience,   one   satisfied
customer at a time.<br/><br/>
  </div>
</div>`;

  const arrayOfTemplates = [
    firstTemplate,
    secondTemplate,
    thirdTemplete,
    fourthTemplate,
    fifthTemplate,
    sixthTemplate,
  ];
  return arrayOfTemplates[Math.floor(Math.random() * 5) ?? 0];
};

export const sendEventToGTM = (event, additionalProps = null) => {
  // Skip if not in browser environment
  if (typeof window === "undefined") {
    return;
  }

  // Initialize dataLayer if it doesn't exist
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  window.dataLayer.push({
    event,
    ...additionalProps,
  });
};

export const deSlugifySlug = (slug, charachter = "-") => {
  if (!slug) return null;
  const arr = slug?.split(charachter);
  arr.pop();
  return arr.join(" ");
};

export const sanitizeStringForParams = (data) => {
  if (!data) return null;
  return data.replace(/[^\w\s]/g, "").replace(/\s+/g, "_");
};

//without query param
export const getCleanUrl = (url) => {
  if (!url) return null;
  const newUrl = new URL(url);
  return newUrl.origin + newUrl.pathname;
};

export const pushEventTracking = (name, eventBody = {}) => {
  if (window && window.dataLayer) {
    window.dataLayer.push({
      event: name ?? "NO_NAMED_EVENT",
      ...eventBody,
    });
  }
};

export const getRandom = (min, max) => {
  min = Math.ceil(min) ?? 0;
  max = Math.floor(max) ?? 100;
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const formatDate = (date) => {
  if (!date) return null;
  return moment(date).format("Do MMM YYYY");
};

export const generateSocialMediaLinks = (
  socialMediaType,
  url,
  utmParameters
) => {
  if (!url && typeof window === "undefined") {
    return "";
  }
  let siteLink = url || window.location.href;
  if (utmParameters) {
    const params = new URLSearchParams(utmParameters).toString();
    siteLink = siteLink.includes("?")
      ? `${siteLink}&${params}`
      : `${siteLink}?${params}`;
  }

  switch (socialMediaType) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${siteLink}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?text=${siteLink}`;
    case "linkedin":
      return `https://www.linkedin.com/shareArticle?mini=true&url=${siteLink}`;
    case "pinterest":
      return `https://pinterest.com/pin/create/button/?url=&media=${siteLink}`;
    default:
      return siteLink;
  }
};

export function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    const context = this;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
}

export const PLACEHOLDER_IMAGE =
  "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709536180.svg";

export const WHATSAPP_CONTACT_LINK =
  "https://wa.me/9867099519?text=Hi%20Elchemy%20Team%2C%0AI%27m%20interested%20in%20following%20products%2C%20could%20you%20please%20help%3F%0AProduct%20Name%3A%0AQuantity%3A%0ADestination%3A%0AApplication%3A%0ALooking%20forward";

export const formatDateToGMT4 = (dateString) => {
  if (!dateString) {
    const now = new Date();
    return formatDateWithTimezone(now);
  }

  const date = new Date(dateString);
  return formatDateWithTimezone(date);
};

export const formatDateWithTimezone = (date) => {
  const localDate = new Date(date);

  // Get the date parts in the local time zone
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, "0");
  const day = String(localDate.getDate()).padStart(2, "0");
  const hours = String(localDate.getHours()).padStart(2, "0");
  const minutes = String(localDate.getMinutes()).padStart(2, "0");
  const seconds = String(localDate.getSeconds()).padStart(2, "0");

  // Return the formatted date with the specified timezone
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${TIMEZONE_OFFSET}`;
};

/**
 * Generates a URL for a blog post based on its data
 * @param {Object} blog - The blog object containing slug and category information
 * @returns {string} The formatted URL for the blog
 */
export const generateBlogUrl = (blog) => {
  if (!blog) return null;

  if (blog?.yoast_head_json?.canonical) {
    const match = blog.yoast_head_json.canonical.match(/\/wp\/(.+?)\/?$/);
    if (match && match[1]) {
      return `/blogs/${match[1]}`;
    }
  }

  let category = "";

  // Extract category from schema if available
  if (
    blog?.yoast_head_json?.schema &&
    blog.yoast_head_json.schema["@graph"] &&
    blog.yoast_head_json.schema["@graph"][0]?.articleSection
  ) {
    category = blog.yoast_head_json.schema["@graph"][0].articleSection[0];
  } else if (blog?.categories?.slug) {
    // Alternative category source if available
    category = blog.categories.slug;
  } else if (blog?.categories?.name) {
    category = blog.categories.name;
  }

  // Format the category if it exists
  if (category) {
    category = category.replace(/ /g, "-").toLowerCase();
    category = he.decode(category);
  } else {
    return `/blogs/${he.decode(blog.slug)}`;
  }

  return `/blogs/${category}/${he.decode(blog.slug)}`;
};

export const decodeHtmlEntities = (text) => {
  return text
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&#x2F;/g, "/");
};

export const INTL_PAGES = ["/about-us", "/elchemy-tech"];

export const getIntlUrl = (url, isIntl) =>
  isIntl && INTL_PAGES.includes(url) ? `${url}/intl` : url;

export const getCDNImageUrl = (path) => {
  const ENABLE_CDN = true;
  if (!path) return null;
  if (path.startsWith("https://")) {
    return path;
  }
  if (path.startsWith("www.")) {
    return path;
  }
  if (ENABLE_CDN) {
    return `https://d3eh91hyrk4vzb.cloudfront.net/${path}`;
  } else {
    return `${S3_BASE_URL}/us-website/${path}`;
  }
};

// Sizes the backend sends on a blog post's `featured_image`: `card_url` is the
// WordPress 768px rendition for listing cards, `url` the full-size image.
export const BLOG_IMAGE_SIZE = {
  CARD: "card_url",
  FULL: "url",
};

/**
 * Image URL for a blog post, or the placeholder when it has no featured image.
 *
 * @param {object} blog - post from /blogs/, /blogs/category/ or /blogs/body/
 * @param {string} [size] - one of BLOG_IMAGE_SIZE
 * @returns {string}
 */
export const getBlogImageUrl = (blog, size = BLOG_IMAGE_SIZE.FULL) =>
  blog?.featured_image?.[size] ?? PLACEHOLDER_IMAGE;
